module.exports = __webpack_public_path__ + "static/media/Mask Group 153.18556fe3.png";